import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const Polymers = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Polymers"
    videos={[
      "https://www.youtube.com/embed/rhFc477fs6s",
      "https://www.youtube.com/embed/l-xOrkLb-Rk",
      "https://www.youtube.com/embed/Yl_4y-JXQkA",
      "https://www.youtube.com/embed/xdnHvWelCPw",
      "https://www.youtube.com/embed/1dG0PmKFsQA",
      "https://www.youtube.com/embed/R6MjI9LEJnU"
    ]}
    takeaways={[
      { text: "Thermosetting and thermoplastic differentiation is frequently asked." },
      { text: "Bakelite and teflon synthesis have to be learnt." }
    ]}
    questions={[
      "Distinguish between thermoplastics and thermosetting plastics, providing suitable examples. Explain the synthesis and applications of a polymer used in the manufacturing of electric switch-boards.",
      "Classify conducting polymers. How can the conductivity of polyacetylene be improved? Discuss with proper mechanism.",
      "Discuss the synthetic procedure of ABS and Bakelite polymer.",
      "Discuss about the n-type and p-type semiconductor with proper diagrams? Explain a method in detail with a proper diagram to obtain single crystalline semiconductors."
    ]}
    exampleVideos={[]}
  />
);
}

export default Polymers;
